import PageHeader from '@components/common/PageHeader';
import DataTable from '@components/common/table/DataTable';
import DataTableRow from '@components/common/table/DataTableRow';
import BooleanField from '@components/common/table/editable/BooleanField';
import StringDisplay from '@components/common/table/static/StringDisplay';
import React, { useMemo } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import { usePaginatedQuery } from '@components/common/pagination/usePaginatedQuery';
import LoadingPage from '@components/common/Loading';
import ErrorPage from '@components/common/Error';
import Paginator from '@components/common/pagination/Paginator';
import { useEmails } from '@components/admin/records/useEmails';
import { InstructorDataConverter } from '@data/user/instructorDataConverter';

const instructorConverter = new InstructorDataConverter();

const PersonnelRecords: React.FC = () => {
  const { result, next, previous, hasNext, hasPrevious, loading, error } = usePaginatedQuery(
    firebase.firestore().collection('instructors').withConverter(instructorConverter),
    25
  );

  const ids = useMemo(() => result?.docs.map((x) => x.id), [result]);

  const [emails, emailsLoading, emailsError] = useEmails(ids, 'getEmailsFromInstructorIds');

  if (loading || emailsLoading) {
    return <LoadingPage></LoadingPage>;
  }

  if (error || emailsError || !result || !emails) {
    return <ErrorPage></ErrorPage>;
  }

  return (
    <div className='w-full h-full overflow-auto'>
      <PageHeader text='PERSONNEL RECORDS'></PageHeader>
      <DataTable
        headers={['First Name', 'Last Name', 'Email', 'Class of', 'Chapter Name', 'Workshop']}
      >
        {result.docs.map((doc) => {
          const docData = doc.data();

          const updateWorkshop = (value: boolean) => {
            doc.ref.update({ workshopAttended: value });
          };

          return (
            <DataTableRow key={doc.id}>
              <StringDisplay value={docData.static.firstName}></StringDisplay>
              <StringDisplay value={docData.static.lastName}></StringDisplay>
              <StringDisplay
                value={emails.find((x) => x.id === doc.id)?.email ?? 'N/A'}
              ></StringDisplay>
              <StringDisplay value={docData.static.classOf.toString()}></StringDisplay>
              <StringDisplay value={docData.static.chapter}></StringDisplay>
              <BooleanField
                initialValue={docData.workshopAttended}
                onChange={updateWorkshop}
              ></BooleanField>
            </DataTableRow>
          );
        })}
      </DataTable>
      <Paginator onNext={next} onPrevious={previous} hasNext={hasNext} hasPrevious={hasPrevious} />
    </div>
  );
};

export default PersonnelRecords;
